var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-progress"},[_c('div',{staticClass:"labels"},[_c('p',{staticClass:"caption"},[_vm._v(_vm._s(_vm.caption))]),_c('p',{staticClass:"subcaption"},[_vm._v(_vm._s(_vm.subcaptionDisplay))])]),_c('div',{staticClass:"bar"},[_c('div',{staticClass:"progress",style:({
				width: _vm.currentValue * 100 + '%',
			})})])])
}
var staticRenderFns = []

export { render, staticRenderFns }